// 列表页 FAQ：原生 <details> 的开合高度动画（渐进增强——脚本未加载时原生展开/收起仍可用）
(function () {
  function initItem(details) {
    if (details.dataset.vlFaqReady === 'true') return;
    var summary = details.querySelector('.vl-faq__summary');
    var body = details.querySelector('[data-vl-faq-body]');
    if (!summary || !body) return;
    details.dataset.vlFaqReady = 'true';
    var busy = false;

    summary.addEventListener('click', function (ev) {
      ev.preventDefault();
      if (busy) return;
      busy = true;
      var isOpen = details.hasAttribute('open');
      var start = body.getBoundingClientRect().height;
      var DURATION = 280;

      function done(fn) {
        var finished = false;
        function onEnd() {
          if (finished) return;
          finished = true;
          body.style.transition = '';
          body.style.height = '';
          busy = false;
          if (fn) fn();
        }
        body.addEventListener('transitionend', onEnd, { once: true });
        window.setTimeout(onEnd, DURATION + 80); // 兜底（transitionend 可能不触发）
      }

      body.style.transition = 'height ' + DURATION + 'ms ease';

      if (isOpen) {
        body.style.height = start + 'px';
        requestAnimationFrame(function () {
          body.style.height = '0px';
          done(function () { details.removeAttribute('open'); });
        });
      } else {
        details.setAttribute('open', '');
        body.style.height = '0px';
        requestAnimationFrame(function () {
          var target = body.scrollHeight;
          body.style.height = target + 'px';
          done(null);
        });
      }
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('details[data-vl-faq]').forEach(initItem);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (ev) { initAll(ev.target); });
})();
